import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import { GetResources, updateUrlParameter, convertDateToUTC } from "../scripts/ResourceManager.js";
import { HeaderFooter } from "./HeaderFooter";
import { Popup, ConfirmationPopupContent } from "./Popup";
import moment from "moment";
import SectionHeader from "./SectionHeader";
import VersionGrid from "./VersionGrid";
import VersionForm from "./VersionForm";
//import { adalApiFetch } from '../adalConfig';
import { adalConfigOptions } from '../adalConfig';
const loggedinAdalInstance = window.parent._adalInstance;

export class Admin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadData: {}, loading: true, resources: GetResources(), isAuthorized: null, dialogKey: "", deleteIndex: -1, formKey: "AdminDashboard", editIndex: -1, apiResponse: ""
        };

        this.ToggleLanguage = this.ToggleLanguage.bind(this);
        this.DeleteVersion = this.DeleteVersion.bind(this);
        this.ShowDialog = this.ShowDialog.bind(this);
        this.ShowDeleteDialog = this.ShowDeleteDialog.bind(this);
        this.CloseDialog = this.CloseDialog.bind(this);
        this.ShowNewForm = this.ShowNewForm.bind(this);
        this.ShowEditForm = this.ShowEditForm.bind(this);
        this.ShowForm = this.ShowForm.bind(this);
        this.SaveForm = this.SaveForm.bind(this);
        this.CancelForm = this.CancelForm.bind(this);
        this.FormatPublishedDates = this.FormatPublishedDates.bind(this);
        adalConfigOptions.then(
            configValues => {
                var adalConfigValues = configValues;
                if (loggedinAdalInstance._user != null) {
                    adalConfigValues.adalApiFetch(fetch, 'https://graph.microsoft.com/v1.0/me/memberOf?$top=500', {})
                        .then((response) => {

                            // This is where you deal with your API response. In this case, we            
                            // interpret the response as JSON, and then call `setState` with the
                            // pretty-printed JSON-stringified object.
                            response.json()
                                .then((responseJson) => {
                                    //this.setState({ apiResponse: JSON.stringify(responseJson, null, 2) });
                                    //"47e74d96-6f69-49e2-9080-fef21899d245";
                                    var group = responseJson.value.filter(function (i) {
                                        return i.id === adalConfigValues.authGroup;
                                    });

                                    //To remove
                                    //fetch('api/admin/Admin/FetchDownloadInfo')
                                    //    .then(response => response.json())
                                    //    .then(data => {
                                    //        this.FormatPublishedDates(data.versionData);
                                    //        data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                                    //        this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads, isAuthorized: true });
                                    //    });
                                    //To Remove

                                    if (group.length > 0)
                                    {
                                        fetch('api/admin/Admin/FetchDownloadInfo')
                                            .then(response => response.json())
                                            .then(data => {
                                                this.FormatPublishedDates(data.versionData);
                                                data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                                                this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads, isAuthorized: true });
                                            });
                                    }
                                    else {
                                        this.setState({
                                            isAuthorized: false, loading: false

                                        });
                                    }
                                });
                        })
                        .catch((error) => {

                            // Don't forget to handle errors!
                            console.error(error);
                        });
                }
            }
        );
        //fetch('api/admin/Admin/GetClientConfig').then(response => response.json())
        //    .then(config => {
        //        //if (loggedinAdalInstance._user != null && loggedinAdalInstance._user.profile.groups.indexOf("47e74d96-6f69-49e2-9080-fef21899d245") != -1)
        //        {
        //            if (loggedinAdalInstance._user != null) {
        //                adalConfigOptions.adalApiFetch(fetch, 'https://graph.microsoft.com/v1.0/me/memberOf?$top=500', {})
        //                    .then((response) => {

        //                        // This is where you deal with your API response. In this case, we            
        //                        // interpret the response as JSON, and then call `setState` with the
        //                        // pretty-printed JSON-stringified object.
        //                        response.json()
        //                            .then((responseJson) => {
        //                                //this.setState({ apiResponse: JSON.stringify(responseJson, null, 2) });
        //                                //"47e74d96-6f69-49e2-9080-fef21899d245";
        //                                var group = responseJson.value.filter(function (i) {
        //                                    return i.id === config.grKey;
        //                                });
        //                                if (group.length > 0) {
        //                                    fetch('api/admin/Admin/FetchDownloadInfo')
        //                                        .then(response => response.json())
        //                                        .then(data => {
        //                                            data.versionData.sort(function (a, b) { return (b.publishedDate - a.publishedDate); });
        //                                            this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads, isAuthorized: true });
        //                                        });
        //                                }
        //                                else {
        //                                    this.setState({
        //                                        isAuthorized: false, loading: false

        //                                    });
        //                                }
        //                            });
        //                    })
        //                    .catch((error) => {

        //                        // Don't forget to handle errors!
        //                        console.error(error);
        //                    });
        //            }
        //        }
        //    });
    }


    ToggleLanguage() {
        var newLangKey = this.state.resources.langKey == "EN" ? "FR" : "EN";
        if (window.history.pushState) {
            var newurl = updateUrlParameter(window.location.href, "lang", newLangKey);
            window.history.pushState({ path: newurl }, "", newurl);
        }
        this.setState({ resources: GetResources(newLangKey) });
    }

    DeleteVersion(deleteIndex) {
        var newDownloadData = this.state.downloadData;
        var deleteId = newDownloadData[deleteIndex].id;
        fetch('api/admin/Admin/DeleteVersion?versionID=' + deleteId, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => response.json())
            .then((data) => {
                if (data) {
                    this.FormatPublishedDates(data);
                    data.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                    this.setState({ downloadData: data, dialogKey: "", deleteIndex: -1 });
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    ShowDeleteDialog(delIndex) {
        this.setState({ dialogKey: "DeleteConfirmation", deleteIndex: delIndex });
    }

    CloseDialog() {
        this.setState({ dialogKey: "", deleteIndex: -1 });
    }

    ShowDialog() {
        switch (this.state.dialogKey) {
            case "DeleteConfirmation": {
                var versionToDel = this.state.downloadData[this.state.deleteIndex].version;
                var isPublished = this.state.downloadData[this.state.deleteIndex].published;
                var message = "Are you sure you want to delete <strong>" + versionToDel + "</strong >" + (isPublished ? " which is <strong>published</strong>?" : "?");
                return (<Popup dialogKey="DeleteConfirmation" dialogTitle="Delete Confirmation" classNames="" onClose={this.CloseDialog}><ConfirmationPopupContent message={message} okButtonText="Delete" onCancel={this.CloseDialog} onOk={() => this.DeleteVersion(this.state.deleteIndex)} /></Popup>);
            }
        }
        return null;
    }

    ShowNewForm() {
        this.setState({ formKey: "VersionNewForm" });
    }

    FormatPublishedDates(dataArray) {
        dataArray.map((data) => {
            if (!isNaN(data.publishedDate)) {
                data.publishedDate = moment.unix(data.publishedDate / 1000).format('YYYY-MM-DD');
            }
        });
    }

    SaveForm(newFormData, closeForm) {
        var newDownloadData = this.state.downloadData;
        const { editIndex } = this.state;
        if (editIndex > -1) {
            newFormData["modifiedDate"] = convertDateToUTC(new Date()).getTime();
            newDownloadData[editIndex] = newFormData;
        }
        else {
            newFormData["createdDate"] = convertDateToUTC(new Date()).getTime();
            newFormData["modifiedDate"] = convertDateToUTC(new Date()).getTime();
            newDownloadData.push(newFormData);
        }
        newFormData.downloadFileInfo.map((item) => {
            if (item.fileUrl != "") {
                var fUrl = item.fileUrl;
                var fUrlArry = fUrl.split("?");
                if (fUrlArry.length == 2) {
                    item.fileUrl = fUrlArry[0];
                }
            }
        });
        var formData = new FormData();
        newFormData["downloadFileInfo"].map((download, index) => {
            let fupload = document.getElementById("fileUpload_" + index);
            if (fupload.files.length > 0) {
                formData.append(download.fileName, fupload.files[0]);
            }
        });

        formData.append("downloadData", JSON.stringify(newFormData));
        //body: JSON.stringify({ updatedDownloadVersions: JSON.stringify(newDownloadData), uploadedFiles: uploadFiles })

        //headers: {
        //    'Content-Type': 'multipart/form-data'
        //},

        const options = {
            method: 'POST',
            body: formData
        };
        fetch('api/admin/Admin/SaveVersion', options)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    this.FormatPublishedDates(data);
                    data.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                    if (closeForm) {
                        this.setState({ formKey: "AdminDashboard", editIndex: -1, downloadData: data });
                    }
                    else {
                        this.setState({ downloadData: data });
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });

        //fetch('api/admin/Admin/UpdateDownloadVersions', {
        //    method: 'POST',
        //    headers: {
        //        'Content-Type': 'application/json'
        //    },
        //    body: JSON.stringify({ updatedDownloadVersions: JSON.stringify(newDownloadData) })
        //})
        //    .then((response) => response.json())
        //    .then((success) => {
        //        if (success) {
        //            if (closeForm) {
        //                this.setState({ formKey: "AdminDashboard", editIndex: -1, downloadData: newDownloadData });
        //            }
        //            else {
        //                this.setState({ downloadData: newDownloadData });
        //            }
        //        }
        //    })
        //    .catch((error) => {
        //        console.error(error);
        //    });
    }

    CancelForm() {
        //reload data
        this.setState({ downloadData: {}, loading: true, formKey: "AdminDashboard", editIndex: -1 }, () => fetch('api/admin/Admin/FetchDownloadInfo')
            .then(response => response.json())
            .then(data => {
                this.FormatPublishedDates(data.versionData);
                data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads });
            }));
    }

    ShowForm() {
        switch (this.state.formKey) {
            case "AdminDashboard": {
                var Dialog = this.ShowDialog();
                return (<div className={"CA-Dashboard col-12 p-3 px-5 mb-2"}>
                    <SectionHeader><span className={"col-4 px-0 CA-title pl-1"}>Dashboard</span>
                        <span className={"col-8 px-0 pull-right text-right pr-1"}><button className={"CA-newDocument CTA-active ca-primarybtn border-0"} onClick={this.ShowNewForm}>New Document</button></span></SectionHeader><VersionGrid versionData={this.state.downloadData} onVersionDelete={(index) => this.ShowDeleteDialog(index)} onVersionEdit={index => this.ShowEditForm(index)} />{Dialog}</div>);
            }

            case "VersionNewForm": {
                const versionTemplate = { "id": "", "version": "", "publishedDate": moment().format("YYYY-MM-DD"), "published": false, "verionDescriptionEN": "", "verionDescriptionFR": "", "createdDate": 0, "modifiedDate": 0, "downloadFileInfo": [{ "fileTypeName": "Excel add-in", "fileName": "", "fileUrl": "", "fileLinkDescriptionEN": "", "fileLinkDescriptionFR": "", "fileBlobName": "" }, { "fileTypeName": "Leaf application", "fileName": "", "fileUrl": "", "fileLinkDescriptionEN": "", "fileLinkDescriptionFR": "", "fileBlobName": "" }] };
                var formData = versionTemplate;
                return (
                    <VersionForm formData={formData} onCancel={this.CancelForm} onSaveForm={(newFormData, closeForm) => this.SaveForm(newFormData, closeForm)} mobileData={this.state.mobileData} allVersionData={this.state.downloadData} />
                );
            }

            case "VersionEditForm": {
                var formData = this.state.downloadData[this.state.editIndex];
                return (<VersionForm formData={formData} onCancel={this.CancelForm} onSaveForm={(newFormData, closeForm) => this.SaveForm(newFormData, closeForm)} mobileData={this.state.mobileData} allVersionData={this.state.downloadData} />);
            }
        }
        return null;
    }

    ShowEditForm(editIndex) {
        this.setState({ formKey: "VersionEditForm", editIndex: editIndex });
    }

    render() {
        //console.log(this.state.downloadData);
        var Form = this.ShowForm();
        //const { editorState } = this.state;
        return (
            this.state.isAuthorized ? <HeaderFooter langResources={this.state.resources} langToggleClick={this.ToggleLanguage} hasLangToggle={false}>
                {this.state.loading ?
                    <div className="CA-container"><p><em>Loading...</em></p></div> : <div className="CA-container">{Form}</div>}
            </HeaderFooter> :
                this.state.loading ? <div className="CA-container"><p><em>Loading...</em></p></div> :
                    <div>you are not authorized to access the admin portal</div>
            //<div>
            //    <p>API response:</p>
            //    <pre>{this.state.apiResponse}</pre>
            //</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin.js